<template>
    <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(tags)"
            :fields="$dataTableFieldsMaker(fields)"
            hover
            :pagination="{ ...pagination, change: fetchTags }"
            addTableClasses="bg-white"
        >
            <template #name="{item}">
                <td>{{ allTags.find(tg => tg.text === item.name) ? allTags.find(tg => tg.text === item.name).label : item.name }}</td>
            </template>
            <template #createdAt="{item}">
                <td>
                    {{ $moment(item.created_at).format('LLL') }}
                </td>
            </template>
        </CDataTable>

        <CModal v-if="editModal.show" :show.sync="editModal.show">
        <template #header-wrapper>
            <div></div>
        </template>

        edit tag

        <template #footer-wrapper>
            <div></div>
        </template>
    </CModal>
    </CRow>
</template>

<script>
import fields from './fields'
import { mapGetters, mapActions } from 'vuex'
import allTags from '@/common/tags'

export default {
    name: 'List',

    components: {
        //
    },

    data() {
        return {
            fields,
            allTags,
            editModal: {
                show: false,
                item: {}
            },
        }
    },

    computed: {
        ...mapGetters({
            tags: 'tag/tags',
            pagination: 'tag/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    methods: {
        ...mapActions({
            fetch: 'tag/fetch',
            // setMsg: 'messageComponent/setMsg',
            // resetMsg: 'messageComponent/resetMsg',
            // setCToast: 'toastComponent/setCToast',
            // setShowLoading: 'loadingComponent/setShowLoading',
        }),
        fetchTags(activePage, params = false) {
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields
            })

            this.pagination.page = activePage
        },
    },
}
</script>